// extracted by css-extract-rspack-plugin
export default {"completeIcon":"Complete_completeIcon__tFXgD","description":"Complete_description__wFe+G","title":"Complete_title__neWwE"};